import { __assign } from "tslib";
import React from 'react';
import { CommentEnd, DoubleCommentEnd, CommentStart, DoubleCommentStart, } from '../components/comments';
import { useConfig } from '../components/config-context';
import { Text } from '../components/text';
export var GenericImage = function (_a) {
    var src = _a.src, _b = _a.cssClass, cssClass = _b === void 0 ? '' : _b, _c = _a.width, width = _c === void 0 ? 'auto' : _c, _d = _a.align, align = _d === void 0 ? 'center' : _d, href = _a.href, style = _a.style, probableWidth = _a.probableWidth, probableHeight = _a.probableHeight, _e = _a.imgStyle, imgStyle = _e === void 0 ? {} : _e, alt = _a.alt, height = _a.height, override = _a.override, overrideProps = _a.overrideProps, showAfterLoad = _a.showAfterLoad;
    var imageMaxWidth = parseInt(width, 10)
        ? parseInt(width, 10) + "px"
        : '100%';
    var implementations = useConfig().implementations;
    var wrapperDefaultProps = {
        className: cssClass,
        style: __assign({ display: 'inline-block', maxWidth: imageMaxWidth }, style),
    };
    var outlookHeight = height ? { height: height } : {};
    var props = href
        ? __assign(__assign({}, wrapperDefaultProps), { href: href, target: '_blank' }) : wrapperDefaultProps;
    return (React.createElement(Text, { align: align, padding: "0px", override: override, overrideProps: overrideProps },
        React.createElement("a", __assign({}, props),
            React.createElement(implementations.Image, __assign({ src: src, width: probableWidth || width }, outlookHeight, { style: __assign({ display: 'inline-block', maxWidth: '100%', width: width, verticalAlign: 'middle' }, imgStyle), alt: alt, probableHeight: probableHeight, showAfterLoad: showAfterLoad })))));
};
export var GenericImageWithSplitResolutionsForOutlook = function (_a) {
    var src = _a.src, srcNonRetina = _a.srcNonRetina, _b = _a.cssClass, cssClass = _b === void 0 ? '' : _b, _c = _a.align, align = _c === void 0 ? 'center' : _c, href = _a.href, maxHeight = _a.maxHeight, alt = _a.alt, showAfterLoad = _a.showAfterLoad;
    var wrapperDefaultProps = {
        className: cssClass,
        style: {
            display: 'inline-block',
            maxWidth: '100%',
            maxHeight: maxHeight,
        },
    };
    var props = href
        ? __assign(__assign({}, wrapperDefaultProps), { href: href, target: '_blank' }) : wrapperDefaultProps;
    var commonImageProps = {
        width: 'auto',
        style: {
            display: 'inline-block',
            maxWidth: '100%',
            width: 'auto',
            verticalAlign: 'middle',
            maxHeight: maxHeight,
        },
    };
    var _d = useConfig(), renderComments = _d.renderComments, implementations = _d.implementations;
    return (React.createElement("div", { style: { textAlign: align } },
        React.createElement("a", __assign({}, props),
            renderComments && (React.createElement(React.Fragment, null,
                React.createElement(CommentStart, { condition: "if mso" }),
                React.createElement("img", __assign({ src: srcNonRetina }, commonImageProps, { alt: alt })),
                React.createElement(CommentEnd, null))),
            React.createElement(DoubleCommentStart, { condition: "if !mso" }),
            React.createElement(implementations.Image, __assign({ src: src }, commonImageProps, { alt: alt, probableHeight: maxHeight ? parseInt(maxHeight, 10) : undefined, showAfterLoad: showAfterLoad })),
            React.createElement(DoubleCommentEnd, null))));
};
//# sourceMappingURL=generic-image.js.map